import React from 'react';
import { useRouteError } from 'react-router-dom';
import AppErrorPage from './AppErrorPage';
import { normalizeAppError } from '../../errors/normalizeAppError';

/**
 * React Router `errorElement` — shows route loader/render failures.
 */
const RouteErrorPage: React.FC = () => {
  const routeError = useRouteError();
  const error = React.useMemo(() => normalizeAppError(routeError), [routeError]);
  return <AppErrorPage error={error} />;
};

export default RouteErrorPage;
